"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Dialog = require("../shared/Dialog/DialogActions");
const constants_1 = require("../constants");
const util_1 = require("util");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
class RedeemLoyaltyProgram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: constants_1.ProgressState.Loading,
            customerLoyaltyProgramInfo: null,
            imgWith: '50%',
            businessName: ''
        };
    }
    render() {
        let content;
        if (this.state.status === constants_1.ProgressState.Success) {
            content = this.renderData(this.state.customerLoyaltyProgramInfo);
        } else if (this.state.status === constants_1.ProgressState.Failed) {
            content = React.createElement("h4", null, " Somethings went Wrong ");
        } else {
            content = React.createElement("div", { className: "text-center mt-2" }, React.createElement(LoadingSpinner_1.default, null));
        }
        return React.createElement("div", { className: "redeem-coupon" }, React.createElement("div", { className: "panel-heading" }, React.createElement("h2", null, "Redeem Loyalty Program")), React.createElement("div", { className: "container-fluid mt-2" }, content));
    }
    componentDidMount() {
        const code = window.location.pathname.split('redeem/')[1];
        api_1.doGet(api_1.API.v1.LOYALTY_PROGRAM_INFO(code)).then(res => {
            let imgWith = this.state.imgWith;
            const img = new Image();
            img.onload = () => {
                if (window.innerWidth < 500) {
                    imgWith = "90%";
                    if (img.width > img.height) {
                        imgWith = "100%";
                    }
                } else if (img.width < img.height) {
                    imgWith = "30%";
                }
                this.setState({ status: constants_1.ProgressState.Success, customerLoyaltyProgramInfo: res.data.customerLoyaltyProgramInfo, businessName: res.data.customerLoyaltyProgramInfo.businessName, imgWith });
            };
            if (util_1.isNullOrUndefined(res.data.customerLoyaltyProgramInfo.image)) {
                this.setState({ status: constants_1.ProgressState.Success, customerLoyaltyProgramInfo: res.data.customerLoyaltyProgramInfo, imgWith: null });
            } else {
                img.src = res.data.customerLoyaltyProgramInfo.image;
            }
        }).catch(error => {
            this.setState({ status: constants_1.ProgressState.Failed });
            api_1.handleError(error);
        });
    }
    renderData(info) {
        return React.createElement("div", { className: "panel mt-2" }, React.createElement("div", { className: "panel-heading" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-6" }, "Your promo"), React.createElement("div", { className: "col-xs-6 text-right" }, React.createElement("button", { className: "btn redeemLoyaltyProgramBtn", onClick: () => this.redeemLoyaltyProgram() }, "Redeem")))), React.createElement("div", { className: "panel-body row" }, React.createElement("div", { className: "col-xs-12 text-center" }, React.createElement("h3", { className: "text-center text-danger" }, info.name), React.createElement("h4", { className: "text-center text-danger" }, info.description), info.image && React.createElement("img", { alt: 'image', className: "", src: info.image, width: this.state.imgWith }))));
    }
    redeemLoyaltyProgram() {
        const code = window.location.pathname.split('redeem/')[1];
        Dialog.showConfirmDialog({
            title: "Redeem Loyalty Program",
            message: "Are you sure you want to redeem?",
            onPositive: () => {
                this.setState({ status: constants_1.ProgressState.Loading }, () => {
                    api_1.doPut(api_1.API.v1.REDEEM_LOYALTY_PROGRAM(code)).then(res => {
                        this.setState({ status: constants_1.ProgressState.Success, customerLoyaltyProgramInfo: res.data.customerLoyaltyProgramInfo });
                        Dialog.showAlertDialog({
                            title: "Successful redemption",
                            message: "Your redemption process finished successfully, you can take take present.",
                            buttonText: "Ok"
                        });
                    }).catch(error => {
                        this.setState({ status: constants_1.ProgressState.Failed });
                        api_1.handleError(error);
                    });
                });
            }
        });
    }
}
exports.default = RedeemLoyaltyProgram;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/RedeemLoyaltyProgram.tsx
// module id = 1360
// module chunks = 1 2